import { jsx } from "react/jsx-runtime";
const CheckmarkCircle = ({ className = 'tw-fill-current', size = 32, ...rest })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        ...rest,
        children: /*#__PURE__*/ jsx("path", {
            className: "tw-fill-current",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z"
        })
    });
export { CheckmarkCircle };
